import styles from "./NewChat.module.css";
import PromptSection from "./PromptSection/PromptSection";
import { useSelector, useDispatch } from "react-redux";
import { uiAction } from "../../store/ui-gemini";
import { SHORT_DESC } from "../../constants/index";
import ScrollChat from "./ScrollChat/ScrollChat";
import useBodyTourStep from "../../hooks/use-body-tour-step";

const NewChat = () => {
  const dispatch = useDispatch();
  const isSideBarLong = useSelector((state) => state.ui.isSidebarLong);
  const userDetails = useSelector((state) => state.user.user);
  const messages = useSelector((state) => state.chat.messages);
  const config = useSelector((state) => state.user.config);
  const isLogin = useSelector((state) => state.user.isLogin);

  const sideBarCloseHandler = () => {
    if (isSideBarLong === true) {
      dispatch(uiAction.toggleSideBar());
    }
  };



  const step = useBodyTourStep()

  const isTour = step === 4 || step === 5;

  return ( !isTour && messages.length === 0 ? (
    <div className={styles["newchat-main"]} onClick={sideBarCloseHandler}>
      <div className={styles["text-section"]}>
        <h1 data-tour="hello" className="text-4xl font-bold text-gray-300">
          {userDetails?.name
            ? `Hello, ${userDetails?.name.split(" ")[0]}`
            : "Hello"}
        </h1>
        <h2 className="animate-fadeIn !text-black">
          {(!isLogin ? config?.landingDescription : userDetails?.config?.landingDescription) || SHORT_DESC}
        </h2>
      </div>
      <PromptSection />
    </div>
  ) : <ScrollChat />);
};

export default NewChat;
